import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingPorkManureStorage, setFootprintingPorkManureStorageAdmin } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PORK_MANURE_STORAGE } from "consts";

import { FootprintingPorkManureStoragePayload } from "models";

export const useMutateFootprintingPorkManureStorage = (farmId: string, year: number, payload: FootprintingPorkManureStoragePayload, primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PORK_MANURE_STORAGE, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setFootprintingPorkManureStorageAdmin(payload, primaryDataId) : setFootprintingPorkManureStorage(payload, primaryDataId)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_PORK_MANURE_STORAGE, primaryDataId, isAdmin],
          ...footprintingPorkPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
